import { object, string } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';

export default () => {
    const { REQUIRED_TEXT, MINIMUM_NUMBER_CHARACTERS } = getValidationTexts();

    return object().shape({
        code: string()
            .required(REQUIRED_TEXT)
            .min(5, MINIMUM_NUMBER_CHARACTERS)
            .nullable(),
    });
};
